module.exports = __webpack_public_path__ + "media/packs/images/@exim/exim-logo-9fba36bb9d3b69cd18b6b6b89f45cff1.svg";